// Text utility functions for chart components

// Simple text wrapping - breaks text at spaces to fit within character limit
export function breakTextToLines(text, maxChars = 25) {
  if (!text || text.length <= maxChars) return [text]

  const words = text.split(' ')
  const lines = []
  let currentLine = ''

  for (const word of words) {
    const testLine = currentLine ? `${currentLine} ${word}` : word

    if (testLine.length <= maxChars) {
      currentLine = testLine
    } else {
      if (currentLine) {
        lines.push(currentLine)
        currentLine = word
      } else {
        lines.push(word) // Single word longer than maxChars
      }
    }
  }

  if (currentLine) {
    lines.push(currentLine)
  }

  return lines
}
